export default "__VITE_ASSET__4895rBNS__"